import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll() {
		const response = await axios.get(`${API_URL}/api/Cms/Interests`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async getById(interest_ID) {
		const url = interest_ID
			? `/api/Cms/Interest?id=${interest_ID}`
			: '/api/Cms/Interest';
		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async checkIfIsValidName(name) {
		const url = `/api/Cms/InterestName?name=${name}`;
		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(InterestsData) {
		try {
			await axios.put(`${API_URL}/api/Cms/Interest`, InterestsData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating lifestyle question:', error);
			throw error;
		}
	}
	async deleteById(lifestyle_Question_ID) {
		try {
			await axios.delete(
				`${API_URL}/api/Cms/Interest?id=${lifestyle_Question_ID}`,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
